import { Entity } from '@api';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { BrandsAndProducts } from '@terminal/modules/overview-knowledge-graph/components/brands-and-products/BrandsAndProducts';
import { CompetitorsKnowledgeGraph } from '@terminal/modules/overview-knowledge-graph/components/competitors-knowledge-graph/CompetitorsKnowledgeGraph';
import { GeographicExposureKnowledgeGraph } from '@terminal/modules/overview-knowledge-graph/components/geographic-exposure-knowledge-graph/GeographicExposureKnowledgeGraph';
import { LegacyThemeKnowledgeGraph } from '@terminal/modules/overview-knowledge-graph/components/theme-knowledge-graph/LegacyThemeKnowledgeGraph';
import { useTranslation } from 'react-i18next';

import { RankingMethodologySection } from '../theme-exposure-tab/theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import { OverviewSectionErrorFallback } from './OverviewSectionErrorFallback';
import styles from './OverviewTab.module.scss';

export interface OverviewTabProps {
  entity: Entity;
}

export const OverviewTab = ({ entity }: OverviewTabProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <div className={styles.root}>
      <div className={styles.gridContainer}>
        <div className={styles.styledThemeKnowledgeGraph}>
          <ErrorBoundaryWrapper
            fallback={
              <OverviewSectionErrorFallback
                title={t('widget:assetOverview.themes')}
              />
            }
          >
            <LegacyThemeKnowledgeGraph
              entityTag={entity.tag}
              isInDrawer={false}
            />
          </ErrorBoundaryWrapper>
        </div>
        <div className={styles.styledBrandsAndProducts}>
          <ErrorBoundaryWrapper
            fallback={
              <OverviewSectionErrorFallback
                title={t(
                  'widget:assetOverview.knowledgeGraph.subtab.brandsAndProducts'
                )}
              />
            }
          >
            <BrandsAndProducts entity={entity} />
          </ErrorBoundaryWrapper>
        </div>
        <div className={styles.styledCompetitorsKnowledgeGraph}>
          <ErrorBoundaryWrapper
            fallback={
              <OverviewSectionErrorFallback
                title={t(
                  'widget:assetOverview.knowledgeGraph.subtab.competitors'
                )}
              />
            }
          >
            <CompetitorsKnowledgeGraph
              entityTag={entity.tag}
              isInDrawer={false}
            />
          </ErrorBoundaryWrapper>
        </div>
        <div className={styles.styledGeographicExposureKnowledgeGraph}>
          <ErrorBoundaryWrapper
            fallback={
              <OverviewSectionErrorFallback
                title={t(
                  'widget:assetOverview.knowledgeGraph.subtab.geographic'
                )}
              />
            }
          >
            <GeographicExposureKnowledgeGraph entity={entity} />
          </ErrorBoundaryWrapper>
        </div>
      </div>
      <RankingMethodologySection rankingType={'companyToTheme'} />
    </div>
  );
};
